import React from 'react';
import { Link } from "react-router-dom";
import "./MainArticle.scss";

const MainArticle = ({ tag, date, title, description, img, size, display, path }) => {

    const data = {tag, date, title, description, img}

    return (
        <Link className="main-article" to={{
            pathname: `/${title.toLowerCase().split(" ").join("-")}`, state: { data }
        }}>
            <div className="main-article__filter"></div>
            <div className="main-article__tag">{tag}</div>
            <div className="main-article__meta">
                <div className="main-article__date">{date}</div>
                <div style={{ fontSize: `${size}` }} className="main-article__title">{title}</div>
                <div className="main-article__description" style={{display: display}}>{description}</div>
            </div>
            <img src={img} alt={title} />
        </Link>
    )
}

export default MainArticle;
